import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';

interface QuestionProps {
  text: string;
}
export const Question: FC<QuestionProps> = ({ text }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
      <Typography component={'div'} variant={'h6'}></Typography>
      <Typography component={'div'} variant={'subtitle1'} dangerouslySetInnerHTML={{ __html: text }}></Typography>
    </Box>
  );
};
